<template>
    <div>
        <el-popover
            placement="top"
            width="300"
            popper-class="myPopover"
            v-model="visible">
            <div class="muban">
                <div class="left">模板文件</div>
                <div class="right">点击下载模板文件</div>
            </div>
            <div class="shuju">
                <div class="left">数据文件</div>
                <div class="right">
                    <div class="right-top">继续上传</div>
                    <div class="text">上传的132个售点中,&nbsp有95个售点符合</div>
                    <div class="text">上传条件有37个售点无法上传</div>

                </div>
            </div>
            <div style="text-align: center; margin: 0">
                <el-button size="mini" type="danger" style="width:70px;margin: 10px 30px 10px 0px" plain @click="visible = false">关闭</el-button>
                <el-button type="danger" size="mini" style="width:70px;" @click="visible = false">确认上传</el-button>
            </div>
            <el-button   type="primary" style="background-color:rgba(0, 117, 255, 1);text-align:center;" @click="addManysale()"  slot="reference">批量添加售点</el-button>
        </el-popover>
        
    </div>
</template>
<script>
   import { mapGetters } from 'vuex'
    export default {
      name: 'activity-report-add-popover',
      props: {
        // channelForm:{type:Array, default:()=>[] },
        // channelTitle:{type:String,default:''},
      },
      data () {
        return {
            visible: false, // Popover批量添加售点       
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.init()
      },
      mounted () {},
      updated () {
      },
      methods: {
        init () {},
        // 通过
        passThrough (item) {
            console.log(item,'通过--son');
            this.$emit("passThrough",item)
        },
        // 退回
        sendBack (item) {
            console.log(item,'退回-son');
            this.$emit("sendBack",item)
        },
        addSale () {
            console.log('333');
            this.$emit("showSinglemask")
        },
        addManysale () {
            // this.$emit("showManymask")
        },    
    }
}
</script>
<style lang="scss">
    .el-popover.myPopover{
        .muban {
            display: flex;
            color: #101010;
            height: 40px;
            line-height: 40px;
            .left {
                width: 25%;
                font-size: 14px;
                font-weight: bold;
            }
            .right {
                font-size: 12px;
                color: rgb(0, 117, 255);
                cursor: pointer;
            }
        }
        .shuju {
            display: flex;
            color: #101010;
            .left {
                width: 25%;
                font-size: 14px;
                font-weight: bold;
                height: 40px;
                line-height: 40px;
            }
            .right {
                font-size: 12px;
                color: rgb(0, 117, 255);
                cursor: pointer;

                // height: 20px;
                // line-height: 20px;
                .right-top {
                    height: 25px;
                    width: 70px;
                    line-height: 25px;
                    color: #FFFFFF;
                    background-color: rgb(0, 117, 255);
                    border-radius: 3px;
                    text-align: center;
                    margin-top: 7.5px;
                }
                .text {
                    height: 20px;
                    line-height: 20px;
                    color: #CD1231;
                }
            }
        }
    }

</style>
